import { BaSeParagraph, BaSeSmall2 } from '@base/react';
import React from 'react';
import { Container, ContainerLabel } from './style';

function Select({
  options,
  label,
  onChange,
  isOptional = false,
  isDisabled = false,
  placeholder = '',
  value,
}) {
  return (
    <Container>
      <ContainerLabel>
        {label && <BaSeParagraph color="#0015C1">{label}</BaSeParagraph>}
        {isOptional && <BaSeSmall2 color="#215DF4">(Opcional)</BaSeSmall2>}
      </ContainerLabel>

      <select
        style={{ color: '#243342' }}
        onChange={onChange}
        value={value ?? ''}
        disabled={isDisabled}
      >
        {placeholder && (
          <option value="" disabled selected>
            {placeholder}
          </option>
        )}

        {options.map((option) => (
          <option key={option.id} value={JSON.stringify(option)}>
            {option.label}
          </option>
        ))}
      </select>
    </Container>
  );
}

export default Select;
